<template>
  <v-navigation-drawer permanent app clipped width="90" color="white">
    <div class="sidebar">
      <div class="logo-container">
        <img class="logo" src="../assets/logo.svg" alt="EpicFlow Logo" />
      </div>
      <div class="links">
        <div class="test"></div>
        <div class="sidebar-links">
          <SideBarLink to="/pipeline" icon="pipeline" name="PIPELINE" />
          <SideBarLink to="/dashboard" icon="dashboard" name="DASHBOARD" />
          <SideBarLink to="/graphs" icon="graphs" name="GRAPHS" />
          <SideBarLink to="/events" icon="events" name="EVENTS" />
          <SideBarLink v-if="$store.state.isAdmin" to="/admin" icon="admin" name="ADMIN" />
        </div>
        <div class="bottom-buttons">
            <HelpButton />
            <LogoutButton />
            <ProfileButton />
          </div>
      </div>
    </div>
  </v-navigation-drawer>
</template>

<script>
import axios from "axios";
import { NetworkHandler } from "@/pipeline/networkHandler.js";

import SideBarLink from "./SideBarLink";
import HelpButton from "./SideBarButtons/HelpButton";
import LogoutButton from "./SideBarButtons/LogoutButton";
import ProfileButton from "./SideBarButtons/ProfileButton";
export default {
  name: "SideBar",
  props: {},
  components: {
    SideBarLink,
    HelpButton,
    LogoutButton,
    ProfileButton,
  },
    data(){
      return{
      showAdmin: false,
      }
    },
  methods: {
    async showAdminIfAllowed(){
      this.showAdmin = await this.$store.state.networkHandler.checkisAdmin();
    }
  },
  async mounted() {
    this.$store.state.sideBar = this;
    //this.showAdminIfAllowed();
  },

  watch: {
    async $route(to, from) {
      const allowedLinks = ["/login", "/resendverification", "/verifyemail", "/signup", "/resetpassword", "/sendpasswordlink", "/forgotpassword"];

      if (this.$cookies.get("sessionID") != null) {
        this.$store.state.loggedIn = true;
      }

      if (!this.$store.state.loggedIn && !allowedLinks.includes(to.path)) {
        this.$toast.error("You need to login before being able to use the simulator!", { position: "bottom-right", timeout: 7500, queue: false });
        this.$router.push("login");
      }
    },
  },
};
</script>

<style>
:root {
  --sidebar-item-hover: rgba(255, 255, 255, 0.16);
  --sidebar-item-active: rgba(255, 255, 255, 0.16);
}
</style>

<style scoped>
.simName {
  background-color: var(--background-color) !important;
  width: 100%;
  bottom: 0px;
  white-space: nowrap;
  position: absolute;
  text-align: center;
  justify-content: center;
}

.autoName {
  background-color: var(--background-color) !important;
  width: 100%;
  bottom: 20px;
  font-size: 0.8em;
  white-space: nowrap;
  position: absolute;
  text-align: center;
  justify-content: center;
}
.logo-container {
  width: 100%;
  height: 70px;
  min-height: 70px;
  margin-top: 0;
  overflow: hidden;
}

img.logo {
  padding-left: 22px;
  padding-top: 20px;
}
.sidebar-links {
  width: 100%;

  
}

.bottom-links {
  width: 100%;

  float: bottom;
}
.bottom-buttons {
  width: 100%;
}
.links {
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
  justify-content: space-between; /* Equal space between top and bottom */

}

.sidebar {
  width: 100%;
  height: 100%;

  min-height: 750px;


  display: flex;
    flex-direction: column;

  border-right: 1px solid var(--sidebar-item-hover);
  background: rgba(76, 82, 105, 1)
linear-gradient(179.57deg, rgba(83, 106, 198, 0.16) 0.74%, rgba(0, 34, 174, 0.16) 22.89%, rgba(201, 51, 200, 0.16) 47.05%, rgba(255, 55, 80, 0.16) 68.69%, rgba(255, 210, 177, 0.16) 97.38%)

}
</style>
